module.exports = __webpack_public_path__ + "static/img_2685_optimized-4620757387ad76281a414fb07524200f.jpg";